import { useTranslation } from "@1f/react-sdk";
import React from "react";
import { CervedDiffIcon } from "../CervedDiffIcon";
import Stack from "@vapor/react-material/Stack";
import Grid from "@vapor/react-material/Grid";
import Divider from "@vapor/react-material/Divider";
import Button from "@vapor/react-material/Button";
import Autocomplete from "@vapor/react-material/Autocomplete";
import TextField from "@vapor/react-material/TextField";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import ExtendedAccordion from "@vapor/react-extended/ExtendedAccordion";
import AccordionSummary from "@vapor/react-material/AccordionSummary";
import AccordionDetails from "@vapor/react-material/AccordionDetails";
import { ExpandMore as ExpandMoreIcon } from "@mui/icons-material";

export const AnagraficaIndirizziSection = ({
  currentAnagrafica,
  isPG,
  isAddrPaeseIta,
  isAddr2PaeseIta,
  basePaeseList,
  baseProvinciaList,
  baseComuneList,
  baseComuneList2,
  isCessato,
  isNotLastVersion,
  onChange,
  onCopyAddress,
  differences
}) => {
  const { t } = useTranslation();

  return (
    <>
      <Divider variant="standard" sx={{ pt: 2 }} />
      <ExtendedTypography variant="titleSmall" color="primary.main">
        {!isPG
          ? t("anagrafica.anagraficaForm.address")
          : t("anagrafica.anagraficaForm.legSed")}
      </ExtendedTypography>

      {/* Indirizzo principale */}
      <Grid container>
        <Grid item xs={4} sx={{ pr: 2 }}>
          <Autocomplete
            id="ddlAddrPaese"
            size="small"
            fullWidth
            options={basePaeseList}
            sx={{ width: "100%" }}
            isOptionEqualToValue={(option, value) =>
              currentAnagrafica.addrPaeseId === undefined
                ? option.id === value.id
                : option.id === currentAnagrafica.addrPaeseId
            }
            getOptionLabel={(option) => option.nome}
            defaultValue={
              currentAnagrafica.addrPaeseId !== undefined
                ? basePaeseList.filter(
                    (item) => item.id === currentAnagrafica.addrPaeseId
                  )[0]
                : null
            }
            filterOptions={(options, state) => {
              let newOptions = [];
              let toSearch = state.inputValue.toLowerCase();
              options.forEach((element) => {
                if (element.nome.toLowerCase().startsWith(toSearch))
                  newOptions.push(element);
              });
              return newOptions;
            }}
            renderInput={(params) => (
              <TextField {...params} required label="Nazione" />
            )}
            onChange={onChange}
            readOnly={isCessato || isNotLastVersion}
          />
        </Grid>
        <Grid item xs={3} sx={{ pr: 2 }}>
          {isAddrPaeseIta ? (
            <Autocomplete
              id="ddlAddrProvincia"
              size="small"
              fullWidth
              options={baseProvinciaList}
              sx={{ width: "100%" }}
              isOptionEqualToValue={(option, value) =>
                currentAnagrafica.addrProvinciaId === undefined
                  ? option.id === value.id
                  : option.id === currentAnagrafica.addrProvinciaId
              }
              getOptionLabel={(option) => option.nome}
              defaultValue={
                currentAnagrafica.addrProvinciaId !== undefined
                  ? baseProvinciaList.filter(
                      (item) => item.id === currentAnagrafica.addrProvinciaId
                    )[0]
                  : null
              }
              filterOptions={(options, state) => {
                let newOptions = [];
                let toSearch = state.inputValue.toLowerCase();
                options.forEach((element) => {
                  if (element.nome.toLowerCase().startsWith(toSearch))
                    newOptions.push(element);
                });
                return newOptions;
              }}
              renderInput={(params) => (
                <TextField {...params} required label={
                  <>
                    <CervedDiffIcon diff={differences?.addrProvincia} />
                    Provincia
                  </>
                } />
              )}
              onChange={onChange}
              readOnly={isCessato || isNotLastVersion}
            />
          ) : (
            <TextField
              id="txtAddrProvincia"
              label={
                  <>
                    <CervedDiffIcon diff={differences?.addrProvincia} />
                    Provincia
                  </>
                }
              size="small"
              defaultValue={currentAnagrafica.addrProvincia}
              fullWidth
              required
              onChange={onChange}
              inputProps={{ autocomplete: "nope", maxLength: 255 }}
              readOnly={isCessato || isNotLastVersion}
            />
          )}
        </Grid>
        <Grid item xs={5}>
          {isAddrPaeseIta ? (
            <Autocomplete
              id="ddlAddrComune"
              size="small"
              fullWidth
              options={baseComuneList}
              sx={{ width: "100%" }}
              isOptionEqualToValue={(option, value) =>
                currentAnagrafica.addrComuneId === undefined
                  ? option.id === value.id
                  : option.id === currentAnagrafica.addrComuneId
              }
              getOptionLabel={(option) => option.nome}
              value={
                baseComuneList.find(
                  (item) => item.id === currentAnagrafica.addrComuneId
                ) || null
              }
              filterOptions={(options, state) => {
                let newOptions = [];
                let toSearch = state.inputValue.toLowerCase();
                options.forEach((element) => {
                  if (element.nome.toLowerCase().startsWith(toSearch))
                    newOptions.push(element);
                });
                return newOptions;
              }}
              renderInput={(params) => (
                <TextField {...params} required label={
                  <>
                    <CervedDiffIcon diff={differences?.addrComune} />
                    Comune
                  </>
                } />
              )}
              onChange={onChange}
              readOnly={isCessato || isNotLastVersion}
            />
          ) : (
            <TextField
              id="txtAddrComune"
              label={
                  <>
                    <CervedDiffIcon diff={differences?.addrComune} />
                    Comune
                  </>
                }
              size="small"
              defaultValue={currentAnagrafica.addrComune}
              fullWidth
              required
              onChange={onChange}
              inputProps={{ autocomplete: "nope", maxLength: 255 }}
              readOnly={isCessato || isNotLastVersion}
            />
          )}
        </Grid>
      </Grid>
      <Grid container>
        <Grid item xs={8} sx={{ pr: 2 }}>
          <TextField
            id="txtAddrIndirizzo"
            label={
              <>
                <CervedDiffIcon diff={differences?.addrIndirizzo} />
                Indirizzo
              </>
            }
            size="small"
            defaultValue={currentAnagrafica.addrIndirizzo}
            fullWidth
            required
            onChange={onChange}
            inputProps={{ autocomplete: "nope", maxLength: 255 }}
            readOnly={isCessato || isNotLastVersion}
          />
        </Grid>
        <Grid item xs={2} sx={{ pr: 2 }}>
          <TextField
            id="txtAddrN"
            label="N."
            size="small"
            defaultValue={currentAnagrafica.addrN}
            fullWidth
            onChange={onChange}
            inputProps={{ autocomplete: "nope", maxLength: 10 }}
            readOnly={isCessato || isNotLastVersion}
          />
        </Grid>
        <Grid item xs={2}>
          <TextField
            id="txtAddrCap"
            label="CAP"
            size="small"
            value={currentAnagrafica.addrCap}
            fullWidth
            required
            onChange={onChange}
            inputProps={{ autocomplete: "nope", maxLength: 5 }}
            readOnly={isCessato || isNotLastVersion}
          />
        </Grid>
      </Grid>

      <Divider variant="standard" sx={{ pt: 2 }} />

      {/* Indirizzo secondario (accordion) */}
      <ExtendedAccordion defaultExpanded={currentAnagrafica.addr2PaeseId > 0}>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
          <ExtendedTypography variant="titleSmall" color="primary.main">
            {!isPG ? "Indirizzo di domicilio" : "Sede operativa"}
          </ExtendedTypography>
        </AccordionSummary>
        <AccordionDetails sx={{ pl: "15px !important", pr: "15px !important" }}>
          <Stack direction="row" justifyContent="flex-end">
            <Button
              sx={{ width: "fit-content" }}
              variant="contained"
              size="medium"
              onClick={onCopyAddress}
              disabled={isCessato || isNotLastVersion}
            >
              {!isPG ? "Copia da indirizzo di residenza" : "Copia da sede legale"}
            </Button>
          </Stack>
          <Grid container sx={{ mt: 2 }}>
            <Grid item xs={4} sx={{ pr: 2 }}>
              <Autocomplete
                id="ddlAddr2Paese"
                size="small"
                fullWidth
                options={basePaeseList}
                sx={{ width: "100%" }}
                isOptionEqualToValue={(option, value) =>
                  currentAnagrafica.addr2PaeseId === undefined
                    ? option.id === value.id
                    : option.id === currentAnagrafica.addr2PaeseId
                }
                getOptionLabel={(option) => option.nome}
                value={
                  basePaeseList.find(
                    (item) => item.id === currentAnagrafica.addr2PaeseId
                  ) || null
                }
                filterOptions={(options, state) => {
                  let newOptions = [];
                  let toSearch = state.inputValue.toLowerCase();
                  options.forEach((element) => {
                    if (element.nome.toLowerCase().startsWith(toSearch))
                      newOptions.push(element);
                  });
                  return newOptions;
                }}
                renderInput={(params) => (
                  <TextField {...params} label="Nazione" />
                )}
                onChange={onChange}
                readOnly={isCessato || isNotLastVersion}
              />
            </Grid>
            <Grid item xs={3} sx={{ pr: 2 }}>
              {isAddr2PaeseIta ? (
                <Autocomplete
                  id="ddlAddr2Provincia"
                  size="small"
                  fullWidth
                  options={baseProvinciaList}
                  sx={{ width: "100%" }}
                  isOptionEqualToValue={(option, value) =>
                    currentAnagrafica.addr2ProvinciaId === undefined
                      ? option.id === value.id
                      : option.id === currentAnagrafica.addr2ProvinciaId
                  }
                  getOptionLabel={(option) => option.nome}
                  value={
                    baseProvinciaList.find(
                      (item) => item.id === currentAnagrafica.addr2ProvinciaId
                    ) || null
                  }
                  filterOptions={(options, state) => {
                    let newOptions = [];
                    let toSearch = state.inputValue.toLowerCase();
                    options.forEach((element) => {
                      if (element.nome.toLowerCase().startsWith(toSearch))
                        newOptions.push(element);
                    });
                    return newOptions;
                  }}
                  renderInput={(params) => (
                    <TextField {...params} required label="Provincia" />
                  )}
                  onChange={onChange}
                  readOnly={isCessato || isNotLastVersion}
                />
              ) : (
                <TextField
                  id="txtAddr2Provincia"
                  label="Provincia"
                  size="small"
                  value={currentAnagrafica.addr2Provincia || ""}
                  fullWidth
                  onChange={onChange}
                  inputProps={{ autocomplete: "nope", maxLength: 255 }}
                  readOnly={isCessato || isNotLastVersion}
                />
              )}
            </Grid>
            <Grid item xs={5}>
              {isAddr2PaeseIta ? (
                <Autocomplete
                  id="ddlAddr2Comune"
                  size="small"
                  fullWidth
                  options={baseComuneList2}
                  sx={{ width: "100%" }}
                  isOptionEqualToValue={(option, value) =>
                    currentAnagrafica.addr2ComuneId === undefined
                      ? option.id === value.id
                      : option.id === currentAnagrafica.addr2ComuneId
                  }
                  getOptionLabel={(option) => option.nome}
                  value={
                    baseComuneList2.find(
                      (item) => item.id === currentAnagrafica.addr2ComuneId
                    ) || null
                  }
                  filterOptions={(options, state) => {
                    let newOptions = [];
                    let toSearch = state.inputValue.toLowerCase();
                    options.forEach((element) => {
                      if (element.nome.toLowerCase().startsWith(toSearch))
                        newOptions.push(element);
                    });
                    return newOptions;
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Comune" />
                  )}
                  onChange={onChange}
                  readOnly={isCessato || isNotLastVersion}
                />
              ) : (
                <TextField
                  id="txtAddr2Comune"
                  label="Comune"
                  size="small"
                  value={currentAnagrafica.addr2Comune || ""}
                  fullWidth
                  onChange={onChange}
                  inputProps={{ autocomplete: "nope", maxLength: 255 }}
                  readOnly={isCessato || isNotLastVersion}
                />
              )}
            </Grid>
          </Grid>
          <Grid container sx={{ mt: 2 }}>
            <Grid item xs={8} sx={{ pr: 2 }}>
              <TextField
                id="txtAddr2Indirizzo"
                label="Indirizzo"
                size="small"
                value={currentAnagrafica.addr2Indirizzo || ""}
                fullWidth
                onChange={onChange}
                inputProps={{ autocomplete: "nope", maxLength: 255 }}
                readOnly={isCessato || isNotLastVersion}
              />
            </Grid>
            <Grid item xs={2} sx={{ pr: 2 }}>
              <TextField
                id="txtAddr2N"
                label="N."
                size="small"
                value={currentAnagrafica.addr2N || ""}
                fullWidth
                onChange={onChange}
                inputProps={{ autocomplete: "nope", maxLength: 10 }}
                readOnly={isCessato || isNotLastVersion}
              />
            </Grid>
            <Grid item xs={2}>
              <TextField
                id="txtAddr2Cap"
                label="CAP"
                size="small"
                value={currentAnagrafica.addr2Cap || ""}
                fullWidth
                onChange={onChange}
                inputProps={{ autocomplete: "nope", maxLength: 5 }}
                readOnly={isCessato || isNotLastVersion}
              />
            </Grid>
          </Grid>
        </AccordionDetails>
      </ExtendedAccordion>
    </>
  );
};
